module.exports = __webpack_public_path__ + "static/img/test-img-pc.ec4952c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/_temp/test-img-pc.jpg
// module id = 0iO1
// module chunks = 0